// @ts-check
import React from "react";

const LoadingOverlay = ({ message = "Loading...", size = 40, loading = false, children }) => {
  return (
    <div className="relative w-full">
      {/* Content always visible */}
      {children}

      {/* Overlay only inside the bounds of the wrapper */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-10 rounded-xl overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-black/20 to-transparent animate-wave" />
          <div className="z-10 flex flex-col items-center">
            <div
              className="animate-spin rounded-full border-t-4 border-b-4 border-purple-500"
              style={{ width: size, height: size }}
            />
            <p className="mt-2 text-gray-700 text-sm text-center px-4">{message}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingOverlay;